export * from './my-tp-data.generated'
